import IHistoryData from '../../../../../tableEngine/Script/Game/Data/DataObject/History/IHistoryData';
import DataType from '../../../../../tableEngine/Script/Game/Data/Config/DataStructure';
import Lobby from '../../../../System/Lobby';

export default class InGameJackpotHistoryData implements IHistoryData {
    public readonly machineID: number;
    public readonly gameID: string;
    public readonly win: number;
    public readonly bet: number;
    public readonly balance: number;
    public readonly describe: string;
    public readonly hallID: DataType.Enums.HallType;
    public readonly tableID: string;
    public readonly actualRoundID: number;
    public readonly gameBet: number;
    public readonly gameWin: number;
    public readonly transactionID: string;
    public readonly roundID: number;
    public readonly timestamp: number;
    public readonly date: Date;
    public readonly replayable: boolean;
    public readonly level: DataType.Enums.LobbyJackpotLevel;
    public readonly queryMachineNamePromise: Promise<void>;
    private _machineID: string;

    constructor(rawData: DataType.History.JackpotResultData) {
        this.machineID = rawData.TableID;
        this._machineID = rawData.GameID;
        this.gameID = rawData.GameID;
        this.win = rawData.Win;
        this.bet = 0;
        this.balance = 0;
        this.describe = '';
        this.hallID = DataType.Enums.HallType.Normal;
        this.tableID = rawData.TableID.toString();
        this.actualRoundID = rawData.ID;
        this.gameBet = 0;
        this.gameWin = rawData.Win;
        this.level = rawData.Level;
        this.transactionID = rawData.TransactionID;
        this.roundID = rawData.ID;
        this.date = new Date(rawData.Time);
        this.timestamp = this.date.getTime();
        this.replayable = false;
    }

    public get machineName(): string {
        return Lobby.i18n.getMessage(this._machineID.toUpperCase());
    }
}
